<div class="upload-container">
  <div class="upload-card">
    <h2 class="upload-title">
      Choose File Type<span class="required">*</span>
    </h2>

    <div class="options-grid">
      <div
        class="option-card"
        [class.selected]="selectedType === 'google'"
        (click)="selectType('google')"
      >
        <div class="option-radio">
          <span class="radio-circle" [class.checked]="selectedType === 'google'"></span>
        </div>
        <div class="option-icon icon-google">
          <svg viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.5 0C0.67 0 0 0.67 0 1.5V16.5C0 17.33 0.67 18 1.5 18H10.5C11.33 18 12 17.33 12 16.5V5.25L6.75 0H1.5Z" fill="#16A34A"/>
            <path d="M6.75 0V5.25H12L6.75 0Z" fill="#22C55E" opacity="0.6"/>
            <rect x="2.5" y="8" width="7" height="1" rx="0.5" fill="white"/>
            <rect x="2.5" y="10.5" width="7" height="1" rx="0.5" fill="white"/>
            <rect x="2.5" y="13" width="4" height="1" rx="0.5" fill="white"/>
          </svg>
        </div>
        <div class="option-name">Google Sheet</div>
        <div class="option-desc">Connect directly to a live Google Sheet.</div>
      </div>

      <div
        class="option-card"
        [class.selected]="selectedType === 'excel'"
        (click)="selectType('excel')"
      >
        <div class="option-radio">
          <span class="radio-circle" [class.checked]="selectedType === 'excel'"></span>
        </div>
        <div class="option-icon icon-excel">
          <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="18" height="18" rx="2" fill="#3B82F6"/>
            <path d="M10.5 4L8 9L10.5 14H8.75L7 10.5L5.25 14H3.5L6 9L3.5 4H5.25L7 7.5L8.75 4H10.5Z" fill="white"/>
          </svg>
        </div>
        <div class="option-name">Excel/CSV File</div>
        <div class="option-desc">Upload a .XLS/.CSV file, max 20MB</div>
      </div>
    </div>

    <input #fileInput type="file" hidden accept=".xls,.xlsx,.csv" (change)="onFileSelected($event)" />

    <div class="file-status-bar" *ngIf="selectedFile || uploadError">
      <!-- Uploading state -->
      <div class="file-status-item uploading" *ngIf="isUploading && selectedFile">
        <div class="progress-wrapper">
          <mat-progress-spinner class="progress-bg" diameter="20" color="accent" mode="determinate" value="100"></mat-progress-spinner>
          <mat-progress-spinner class="progress-fg" diameter="20" color="primary" mode="determinate" [value]="uploadProgress"></mat-progress-spinner>
        </div>
        <span class="file-name">{{ selectedFile.name }}</span>
        <span class="file-progress-text">Uploading... {{ uploadProgress }}%</span>
      </div>

      <!-- Upload complete state -->
      <div class="file-status-item complete" *ngIf="uploadComplete && selectedFile">
        <mat-icon class="file-done-icon">check_circle</mat-icon>
        <span class="file-name">{{ selectedFile.name }}</span>
        <div class="file-status-actions">
          <button class="next-btn" (click)="goToAnalysing()">Next</button>
        </div>
      </div>

      <!-- Error state -->
      <div class="file-status-item error" *ngIf="uploadError">
        <mat-icon class="file-error-icon">error_outline</mat-icon>
        <span class="file-error-text">{{ uploadError }}</span>
        <button class="retry-btn" (click)="retryUpload()">Retry</button>
      </div>
    </div>
  </div>
</div>
